const translatedValue = (key, t) => {
  const value = t(key);
  return value === key ? '' : value;
};

const getTranslationLanguageLabel = (languageCode, countryCode, t) => {
  const language = String(languageCode || '').trim();
  const country = String(countryCode || '').trim().toUpperCase();
  if (!language) return '';

  if (language.includes('-')) {
    const [baseLanguage, regionalCountry] = language.split('-');
    const regionalLabel = translatedValue(`languages-${language}`, t);
    if (regionalLabel) return regionalLabel;

    const languageLabel = translatedValue(`languages-${baseLanguage}`, t);

    if (baseLanguage === 'en') return languageLabel || language;

    const countryLabel = translatedValue(
      `countries-${regionalCountry.toUpperCase()}`,
      t
    );

    return languageLabel && countryLabel
      ? `${languageLabel} (${countryLabel})`
      : languageLabel || language;
  }

  const regionalLabel = country
    ? translatedValue(`languages-${language}-${country}`, t)
    : '';

  return regionalLabel || translatedValue(`languages-${language}`, t) || language;
};

export default getTranslationLanguageLabel;
